import ImageZoom from "react-image-zoom";

const ImageProductZoom = ({ image, alt }) => {
  return (
    <ImageZoom
      className="img-responsive"
      zoomWidth={500}
      img={image}
      alt={alt}
      scale={1}
      zoomPosition="right"
      zoomLensStyle={{ backgroundColor: "green", opacity: 0.4 }}
      style={{
        border: "1px solid #e5e5e5",
      }}
    />
  );
};

export default ImageProductZoom;
